import * as React from "react";
const SvgEcsysPlus = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 2.4, strokeLinecap: "round", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12 5v14M5 12h14" }));
export default SvgEcsysPlus;
